import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { Link } from 'react-router-dom'
import { HeaderButton } from '../../../components/Header'
import { LOGIN_PATH } from '../../MainRoutes/constants'
import messages from './messages';

function LoginLink() {
  return (
    <FormattedMessage {...messages.loginLink}>
      {message => (
        <HeaderButton
          as={Link}
          to={LOGIN_PATH}
          title={message}
        >
          {message}
        </HeaderButton>
      )}
    </FormattedMessage>
  )
}

export default LoginLink
